import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const marketApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMarkets: builder.query({
      query: filters => {
        const qs = Object.keys(filters).reduce((acc, k) => {
          acc.set(k, filters[k]);
          return acc;
        }, new URLSearchParams());
        return `market/?${qs}`;
      },
      providesTags: ['Market'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetMarketsQuery
} = marketApi;
